import { createLucideIcon } from "lucide-react"
export const LineIcon = createLucideIcon("line", [
  [
    "path",
    {
      d: "M 3 21 C21 3 3 21 21 3",
      key: "17ift4",
    },
  ],
])
